import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import TreatCard from "./TreatCard";
const treatList = [
  {
    id: "1",
    title: "Optimal Growth Factor",
    text: "Maximizes the effectiveness of growth factors and stem cells derived from the patient's blood, crucial for hair follicle rejuvenation and scalp health.",
    addClass: "topl3",
  },
  {
    id: "2",
    title: "Advanced Processing",
    text: "Utilizes a unique, pre-programmed horizontal centrifuge process to prepare the PRF, ensuring the optimal composition for hair regrowth.",
    addClass: "topr3 right",
  },
  {
    id: "3",
    title: "Customized Treatment",
    text: "Tailored to each individual's specific hair loss condition, ensuring personalized and effective treatment.",
    addClass: "midl3",
  },
];
export default function Treat3() {
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 750) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 750) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, []);
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);
  const closeFunc = (e) => {
    if (e.currentTarget === e.target) setModal(null);
  };
  return (
    <>
      <section className="treat" aria-labelledby="xprf-heading">
        <div className="auto__container">
          <div className="treat__inner last">
            <div className="treat__inner-row big">
              <div className="treat__inner-content">
                <h3 id="xprf-heading">
                  <b> X-PRF:</b> Next-Generation Hair Restoration
                </h3>
                <p>
                  <b>
                    "Harnessing the Power of Natural Growth Factors for Optimal
                    Hair Regrowth"-
                  </b>
                  Featuring an eXtra Platelet-Rich Fibrin Protocol, the X-PRF is
                  a groundbreaking advancement in hair restoration therapy that
                  enhances the natural healing and regenerative capabilities of
                  the body, offering a superior alternative to traditional PRP
                  and I-PRF methods.
                </p>
              </div>
              <div className="treat__inner-image" aria-hidden="true">
                <img className="desc" src="/images/treat/shape-3.png" alt="X-PRF hair restoration treatment illustration - desktop view" />
                <img className="mob" src="/images/treat/circle-3.png" alt="X-PRF hair restoration treatment illustration - mobile view" />
              </div>
            </div>
            <div className="treatMain">
              <div className="treatMain__title">
                <hr />
                <h3 id="xprf-features-heading">Key Features</h3>
                <hr />
              </div>
              <div className="treatMain__content">
                <div className="treatMain__image big">
                  <img className="desc" src="/images/treat/3.png" alt="Visual representation of X-PRF technology key features - desktop view" />
                  <img className="mob" src="/images/treat/3-mob.png" alt="Visual representation of X-PRF technology key features - mobile view" />
                </div>
                <div className="treatMain__list" role="list">
                  {treatList.map((item, index) => {
                    return (
                      <TreatItem
                        mobile={mobile}
                        onClick={() => {
                          setModal(true);
                          setModalData(item);
                        }}
                        {...item}
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {modal && (
          <TreatCard
            closeFunc={closeFunc}
            setModal={setModal}
            modalData={modalData}
          />
        )}
      </AnimatePresence>
    </>
  );
}
const TreatItem = (props) => {
  const [active, setActive] = useState(false);
  return (
    <div
      className={"treatItem " + (props.addClass ? props.addClass : "")}
      role="listitem"
    >
      <div
        className="treatItem__title"
        onClick={() => {
          if (props.mobile) {
            props.onClick();
          } else {
            setActive(!active);
          }
        }}
        role="button"
        aria-expanded={active}
        aria-controls={`treat3-item-${props.id}-content`}
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (props.mobile) {
              props.onClick();
            } else {
              setActive(!active);
            }
            e.preventDefault();
          }
        }}
      >
        <h4 id={`treat3-item-${props.id}-title`}>{props.title}</h4>
        <span aria-hidden="true"></span>
      </div>
      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0 }}
            className="treatItem__body"
            id={`treat3-item-${props.id}-content`}
            aria-labelledby={`treat3-item-${props.id}-title`}
          >
            <p className="sm">{props.text}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
